var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85917 3.92195C9.26762 1.21756 6.99719 0 5.00282 0H4.99718C3.00845 0 0.732384 1.21171 0.140833 3.9161C-0.518323 6.93658 1.26196 9.49463 2.87323 11.1044C3.44435 11.6787 4.208 11.9999 5.00282 12C5.76902 12 6.53521 11.7015 7.12677 11.1044C8.73804 9.49463 10.5183 6.94244 9.85917 3.92195ZM5.00282 6.85463C4.76977 6.85463 4.539 6.80694 4.32369 6.71428C4.10838 6.62161 3.91274 6.48579 3.74795 6.31457C3.58316 6.14334 3.45244 5.94007 3.36325 5.71636C3.27407 5.49265 3.22816 5.25288 3.22816 5.01073C3.22816 4.76859 3.27407 4.52881 3.36325 4.3051C3.45244 4.08139 3.58316 3.87812 3.74795 3.7069C3.91274 3.53567 4.10838 3.39985 4.32369 3.30719C4.539 3.21452 4.76977 3.16683 5.00282 3.16683C5.47348 3.16683 5.92487 3.3611 6.25769 3.7069C6.5905 4.05269 6.77747 4.5217 6.77747 5.01073C6.77747 5.49976 6.5905 5.96877 6.25769 6.31457C5.92487 6.66037 5.47348 6.85463 5.00282 6.85463Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.3554f19f57fdd1ec492bba129f0085e4.svg";
export { ForwardRef as ReactComponent };